import * as React from 'react';
import { observer } from 'mobx-react';
import './style.css';
import { Video } from '../../../models';
import { CategoryFavourites } from '../../../stores';
import { VideoTile } from '../../Video/VideoMiniList/VideoTile';

export interface FavouritesListProps {
  favouritesByCategory: Array<CategoryFavourites>;
}

export interface FavouritesListState {
  /* empty */
}

@observer
export class FavouritesList extends React.Component<
  FavouritesListProps,
  FavouritesListState
> {
  render() {
    const { favouritesByCategory } = this.props;

    return (
      <section className="favourites-list">
        <div className="favourites-list-header">
          <h2 className="favourites-list-heading">Your Favourites</h2>
          {/* TODO: Filters? */}
        </div>
        <div className="favourites-list-content">
          {favouritesByCategory.length ? (
            favouritesByCategory.map(this.categoryFavouritesSection)
          ) : (
            <div className="favourites-list-no-favourites-message">
              Looks like you don't have any favourites yet
            </div>
          )}
        </div>
      </section>
    );
  }

  private categoryFavouritesSection = (
    favourites: CategoryFavourites
  ): JSX.Element => {
    const collator = new Intl.Collator();

    return (
      <div
        key={favourites.category.id}
        className="favourites-list-category-section"
      >
        <h3 className="favourites-list-category-section-heading">
          Your favourite {favourites.category.name} videos
        </h3>
        <div className="favourites-list-category-section-content">
          {favourites.videos
            .slice()
            .sort((videoA, videoB) =>
              collator.compare(videoA.name || '', videoB.name || '')
            )
            .map(favourite => (
              <VideoTile
                getVideoUrl={Video.getRoute}
                key={favourite.name}
                video={favourite}
              />
            ))}
        </div>
      </div>
    );
  };
}

export default FavouritesList;



// WEBPACK FOOTER //
// ./src/app/components/UserProfile/FavouritesList/index.tsx